const KEY = 'reconBuildUpdateSnooze';

export function readBuildUpdateSnooze() {
	try {
		const raw = localStorage.getItem(KEY);
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
}

/** @returns {boolean} true if this buildId is still snoozed */
export function isBuildUpdateSnoozed(buildId) {
	const snooze = readBuildUpdateSnooze();
	if (!snooze || !buildId) return false;
	if (snooze.buildId !== buildId) return false;
	return Number(snooze.until) > Date.now();
}

export function snoozeBuildUpdate(buildId, durationMs) {
	localStorage.setItem(KEY, JSON.stringify({
		buildId,
		until: Date.now() + durationMs,
	}));
}

export function clearBuildUpdateSnooze() {
	localStorage.removeItem(KEY);
}
